import React from "react";

const StickyNotes = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      className="swap-off h-4 w-4 fill-current"
    >
      <path d="M448 348.1V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h268.1a48 48 0 0 0 33.9-14.1l83.9-83.9A48 48 0 0 0 448 348.1zm-128 80v-76.1h76.1L320 428.1zM400 80v224H296c-13.3 0-24 10.7-24 24v104H48V80h352z" />
    </svg>
  );
};

export default StickyNotes;
